export enum ContactField {
    Phone = 0,
    ChatName = 1,
    ExternalId = 2,
    ContactName = 3
}